module.exports = __webpack_public_path__ + "static/media/AkkuratBETA-Regular.f3cf2f6e.eot";